import { createSlice } from '@reduxjs/toolkit';

const features = createSlice({
  name: 'FEATURES',
  initialState: {},

  reducers: {
    setIsBounceNavigationAnimationEnabled: (state, action) => {
      state.isBounceNavigationAnimationEnabled =
        action.payload.isBounceNavigationAnimationEnabled;
    },
    setShowBrandMatchCount: (state, action) => {
      state.showBrandMatchCount = action.payload.showBrandMatchCount;
    },
  },
});

const { actions } = features;

export const { setIsBounceNavigationAnimationEnabled, setShowBrandMatchCount } =
  actions;

export default features.reducer;
